import { createContext, useContext, useEffect, useState } from "react";

const KEY = "ll_impersonation";
const ImpersonationContext = createContext(null);

function readStored() {
    try {
        const raw = localStorage.getItem(KEY);
        return raw ? JSON.parse(raw) : null;
    } catch {
        return null;
    }
}

export function ImpersonationProvider({ children }) {
    const [impersonation, setImpersonation] = useState(() => readStored());

    // Keep multiple tabs in sync
    useEffect(() => {
        const onStorage = (e) => {
            if (e.key === KEY) setImpersonation(readStored());
        };
        window.addEventListener("storage", onStorage);
        return () => window.removeEventListener("storage", onStorage);
    }, []);

    const start = (client) => {
        if (!client?.id) return;
        const payload = { id: client.id, name: client.name || "Client" };
        localStorage.setItem(KEY, JSON.stringify(payload));
        setImpersonation(payload);
    };

    const stop = () => {
        localStorage.removeItem(KEY);
        setImpersonation(null);
    };

    return (
        <ImpersonationContext.Provider value={{ impersonation, start, stop }}>
            {children}
        </ImpersonationContext.Provider>
    );
}

export const useImpersonation = () => useContext(ImpersonationContext) || { impersonation: null, start: () => {}, stop: () => {} };

// Utility for non-React modules (api interceptor) to read the current client id
export function getImpersonatedClientId() {
    const cur = readStored();
    return cur?.id || null;
}
